import { render, staticRenderFns } from "./PreAccItemDims.vue?vue&type=template&id=16bafdc2&scoped=true&"
import script from "./PreAccItemDims.vue?vue&type=script&lang=ts&"
export * from "./PreAccItemDims.vue?vue&type=script&lang=ts&"
import style0 from "./PreAccItemDims.vue?vue&type=style&index=0&id=16bafdc2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16bafdc2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VTab,VTabItem})
